import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'
import { useLogEvent } from '~/hooks/useLogEvent'

import { dialogInfoAtom } from '../atoms'
import { useCloseDialogWithRefresh } from '../hooks/useCloseDialogWithRefresh'
import { useRemoveCoreMemberMutation } from '../hooks/useRemoveCoreMemberMutation'

export const DeleteCoreMemberDialog = () => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'delete') {
    throw new Error()
  }
  const { coreMember } = dialogInfo

  const closeDialogWithRefresh = useCloseDialogWithRefresh()
  const logEvent = useLogEvent()
  const removeCoreMemberMutation = useRemoveCoreMemberMutation({
    onSuccess: (data) => {
      // removeCoreMemberは未ログイン時のみnullを返す。対象が既に削除済みの場合を
      // バックエンド側で判別できないため、そのケースの誤記録はここでは防げない。
      if (data.removeCoreMember?.result) {
        logEvent('Delete core member', {
          eventProperties: [{ key: 'email', value: coreMember.email }],
        })
      }
      closeDialogWithRefresh()
    },
  })
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    removeCoreMemberMutation.mutate(coreMember.id)
  }, [coreMember.id, removeCoreMemberMutation])

  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  return (
    <ExecuteCancelDialog
      executing={removeCoreMemberMutation.isPending}
      mode="delete"
      title={t('remove_from_mforce_administrator')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_from_mforce_administrator_confirmation', {
        target: coreMember.email,
      })}
    </ExecuteCancelDialog>
  )
}
